import RichTextHeadline from '../../shared/RichTextHeadline/RichTextHeadline';
import RichTextList from '../../shared/RichTextList/RichTextList';
import { cn } from 'utils/styles';
import { HeroTextSize } from 'components/HeroConsolidated/constants';
import { HeroConsolidatedProps } from '../types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

type HeroContentProps = Pick<
  HeroConsolidatedProps,
  'sys' | 'headline' | 'copy' | 'headlineSize' | 'copySize' | 'headingLevel'
> & {
  copyClassName?: string;
};

const HeroContent = ({
  headline,
  copy,
  sys,
  headlineSize,
  copySize,
  headingLevel,
  copyClassName,
}: HeroContentProps) => {
  const isLargeHeadline = headlineSize === HeroTextSize.Large;
  return (
    <div className={cn('flex flex-col gap-4', { 'gap-8': isLargeHeadline })}>
      <div
        className={cn('text-heading-md md:text-heading-xl font-semibold font-sans', {
          'text-heading-lg md:text-heading-xxxl': isLargeHeadline,
        })}
        {...liveUpdateAttrs(sys?.id, 'headline')}>
        {headline && <RichTextHeadline headline={headline} level={headingLevel || 'h1'} />}
      </div>
      {copy && (
        <div
          className={cn(
            'hero-copy font-serif text-body-serif flex flex-col gap-4',
            { 'font-sans text-heading-sm': copySize === HeroTextSize.Large },
            copyClassName,
          )}
          {...liveUpdateAttrs(sys?.id, 'copy')}>
          <RichTextList item={copy} />
        </div>
      )}
    </div>
  );
};

export default HeroContent;
